<template>
  <div
      :class="noti ? 'scroll_unset' : ''"
      class="OptionDashboard relative"
  >
    <component v-bind:is="OptionComponent"></component>
    <NotificationModal
        @hideNoti="hideNoti"
        @showNoti="showNoti"
    />
  </div>
</template>

<script>
import GeneralOption from './generalOption/index';
import ServiceUseAgreement from './serviceUseAgreement/index';

export default {
  name: 'OptionDashboard',
  components: {
    GeneralOption,
    ServiceUseAgreement,
    NotificationModal: () => import('@/components/modal/notification'),
  },
  data() {
    return {
      noti: false,
      OptionComponent: 'GeneralOption',
      componentName: {
        0: `GeneralOption`,
        1: `ServiceUseAgreement`,
        2: ``,
      },
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.OptionComponent = this.componentName[state.navMenu];
    })
  },
  mounted() {
    this.$store.dispatch('changeNavMenu', 0);
    this.$store.dispatch('changeMainMenu', 4); // settings
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  methods: {
    hideNoti() {
      this.noti = false;
    },
    showNoti() {
      this.noti = true;
    }
  }
}
</script>